export default __webpack_public_path__ + "static/media/toggle-up-icon.d47d8e02.svg";